import cacheService from '../../../services/cacheService';
import submitCommand from '../../../services/submitCommand';
import uuid from '../../../services/uuid';

export const changeSubscription = (
  subscriptionId: string,
  newProductItemSKU: string,
  orgId: string,
  currentItemNumber: string,
  initiatingUserId: string
) => {
  cacheService.removeAllInPath(`/v1/licenses`);

  const id = uuid.generate();
  const cmd = {
    id: id,
    subscriptionId: subscriptionId,
    orgId: { id: orgId },
    oldItemNumber: currentItemNumber,
    newItemNumber: newProductItemSKU,
    initiatingUserId: initiatingUserId,
  };
  return submitCommand(id, cmd, 'ChangeSubscription', 'SubscriptionProductItemChanged', 'SubscriptionChangeFailed');
};
